export const select = {
  MuiSelect: {
    styleOverrides: {
      select: {
        '&.MuiTablePagination-select': {
          minWidth: '1.5rem !important'
        }
      }
    }
  }
}
